<template>
  <div class="home">
    <TheHeader />
    <main class="main">
      <h3 class="title">Moje projekty</h3>
      <div v-if="error">
        {{ error }}
      </div>
      <div v-else>
        <div v-if="projects.length">
          <ProjectsList :projects="projects" />
        </div>
        <div v-else>Loading...</div>
      </div>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import ProjectsList from '@/components/ProjectsList.vue';
import TheFooter from '@/components/TheFooter.vue';
import TheHeader from '@/components/TheHeader.vue';
import getProjects from '@/hooks/getProjects.js';

export default {
  components: {
    ProjectsList,
    TheFooter,
    TheHeader,
  },
  setup() {
    const { projects, error, load } = getProjects();
    load();

    return { projects, error };
  },
};
</script>

<style lang="scss">
.home {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(8rem, fit-content) auto minmax(8rem, fit-content);
}
</style>
